[
  {
    "code": "en",
    "isDefault": true,
    "name": "English",
    "nativeName": "English",
    "flag": "en",
    "hreflang": "en",
    "schemaLang": "en-US"
  },
  {
    "code": "es",
    "isDefault": false,
    "name": "Spanish",
    "nativeName": "Español",
    "flag": "es",
    "hreflang": "es",
    "schemaLang": "es-ES"
  },
  {
    "code": "zh",
    "isDefault": false,
    "name": "Chinese",
    "nativeName": "中文",
    "flag": "zh",
    "hreflang": "zh",
    "schemaLang": "zh-CN"
  },
  {
    "code": "fr",
    "isDefault": false,
    "name": "French",
    "nativeName": "Français",
    "flag": "fr",
    "hreflang": "fr",
    "schemaLang": "fr-FR"
  },
  {
    "code": "de",
    "isDefault": false,
    "name": "German",
    "nativeName": "Deutsch",
    "flag": "de",
    "hreflang": "de",
    "schemaLang": "de-DE"
  },
  {
    "code": "ja",
    "isDefault": false,
    "name": "Japanese",
    "nativeName": "日本語",
    "flag": "ja",
    "hreflang": "ja",
    "schemaLang": "ja-JP"
  },
  {
    "code": "it",
    "isDefault": false,
    "name": "Italian",
    "nativeName": "Italiano",
    "flag": "it",
    "hreflang": "it",
    "schemaLang": "it-IT"
  },
  {
    "code": "ko",
    "isDefault": false,
    "name": "Korean",
    "nativeName": "한국어",
    "flag": "ko",
    "hreflang": "ko",
    "schemaLang": "ko-KR"
  },
  {
    "code": "nl",
    "isDefault": false,
    "name": "Dutch",
    "nativeName": "Nederlands",
    "flag": "nl",
    "hreflang": "nl",
    "schemaLang": "nl-NL"
  },
  {
    "code": "pl",
    "isDefault": false,
    "name": "Polish",
    "nativeName": "Polski",
    "flag": "pl",
    "hreflang": "pl",
    "schemaLang": "pl-PL"
  }
]